import type { OptionallyConditionalItem } from '@lemonade-hq/chat-wizard-common-definitions';
import type { UniclientAction } from '../action';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface BaseRealtimeProps extends UniclientBaseComponentProps {
  readonly presentation?: never;
  readonly channel: string;
  readonly event: string;
  /**
   * @optional
   * For edge cases where the event was sent before the client registered to listen,
   * use TTL on the step, and supply a manual value to show
   */
  readonly manualValue?: unknown; // add specific type in extending interfaces
  readonly onEventAction?: OptionallyConditionalItem<UniclientAction> | OptionallyConditionalItem<UniclientAction>[];
}

export interface LocationDiscoveryItem {
  readonly label: string;
  readonly icon: string;
}

export interface LocationDiscoveryProps extends Omit<BaseRealtimeProps, 'presentation'> {
  readonly presentation: 'locationDiscovery';
  /**
   * The keys of this object should match the keys of the
   * realtime event payload (the payload values should be the amount to show)
   */
  readonly items: Record<string, LocationDiscoveryItem>;
  readonly manualValue?: LocationDiscoveryValue;
}

export const REALTIME_DONE_ATTRIBUTE = '__realtimeDone__';

export type LocationDiscoveryValue = Record<string, number>;

export type RealtimeProps = BaseRealtimeProps | LocationDiscoveryProps;

export type WizardRealtimeProps = RealtimeProps & UniclientWizardComponentBase<'realtime'>;

export function realtime(props: RealtimeProps): WizardRealtimeProps {
  return { ...props, type: 'realtime' };
}
